import React from 'react';
import './Service.css';
import { NavLink } from 'react-router-dom';
import { GiHiveMind } from 'react-icons/gi';
import { LiaDigitalTachographSolid } from 'react-icons/lia';
import { FaCloud, FaArrowRight } from 'react-icons/fa';
import { MdOutlineIntegrationInstructions, MdManageHistory } from 'react-icons/md';
import { GrVmMaintenance } from 'react-icons/gr';

export const Service = () => {
  const services = [
    {
      icon: <GiHiveMind />,
      title: 'Artificial Intelligence',
      description: 'Leverage AI and machine learning to automate processes, gain insights, and drive smarter business decisions across your organization.'
    },
    {
      icon: <LiaDigitalTachographSolid />,
      title: 'Digital Experience Platform',
      description: 'Create seamless, personalized digital experiences for your customers across every touchpoint and channel.'
    },
    {
      icon: <FaCloud />,
      title: 'Cloud & DevOps',
      description: 'Migrate to the cloud and streamline your development pipeline with modern infrastructure and continuous delivery practices.'
    },
    {
      icon: <MdOutlineIntegrationInstructions />,
      title: 'Software Development & Integration',
      description: 'Build custom software solutions and integrate disparate systems to create unified, efficient workflows.'
    },
    {
      icon: <MdManageHistory />,
      title: 'Project Management',
      description: 'Expert project oversight ensuring timely delivery, resource optimization, and alignment with your business objectives.'
    },
    {
      icon: <GrVmMaintenance />,
      title: 'Data & Analytics',
      description: 'Transform raw data into actionable intelligence with modern analytics platforms and data engineering solutions.'
    }
  ];

  return (
    <div className="service-page">
      {/* Hero */}
      <section className="service-hero">
        <div className="container">
          <span className="badge">Our Services</span>
          <h1>IT Services Built for Growth</h1>
          <p>
            We prioritize understanding your unique challenges and goals, ensuring that
            our solutions are technically sound and aligned with your business objectives.
          </p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="section">
        <div className="container">
          <div className="services-grid">
            {services.map((service, index) => (
              <div key={index} className="card service-detail-card">
                <div className="service-detail-icon">{service.icon}</div>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section section-alt">
        <div className="container">
          <div className="section-header">
            <span className="badge">Get Started</span>
            <h2>Ready to Build Something Great?</h2>
            <p>Let's discuss how our services can accelerate your business goals.</p>
          </div>
          <div className="section-cta">
            <NavLink to="/contact" className="btn btn-primary">
              Contact Us <FaArrowRight />
            </NavLink>
          </div>
        </div>
      </section>
    </div>
  );
};
